import React from 'react';
import classes from './OtherSolutionCards.module.scss';
import { MdOutlineArrowOutward } from 'react-icons/md';

const OtherSolutionCards = ({ id, title, description, imageUrl, imagePosition, onClick }) => {
  return (
    <div className={classes.OtherSolutionCards}>
      <div className={classes.LeftSection}>
        <div className={classes.ContentWrapper}>
          <div className={classes.Title}>{title}</div>
          <div className={classes.Description}>{description}</div>
        </div>
        <div className={classes.ViewDetailsBtn}>
          <button className={classes.ViewDetailsBtnText} onClick={onClick}>
            <span>View in Details</span>
            <MdOutlineArrowOutward color='#fff'  />
          </button>
        </div>
      </div>
      <div className={`${classes.RightSection} ${imagePosition}`} >
        <img src={imageUrl} alt={title} className={classes.CardImage}/>
      </div>
    </div>
  );
};

export default OtherSolutionCards;